import React, { Dispatch, SetStateAction } from 'react';
import { Dropdown } from 'react-bootstrap';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { legendValid } from '../../utils/legend.data.util';
import { deadlineTypeList, deadlineTypeValue } from '../../libraries/deadline.type.library';
import { prefixLegend, suffixLegend } from '../../scripts/name.legend.script';

import AppLegend from './Legend';

export interface AppInputDeadlineTypeProps {
  component?: string,
  options: {index: number, item: {id: string, type: string, quantity: string}} | null,
  typeDeadline?: {value: string, valid: boolean},
  paymentDeadlines?: {value: {id: string, type: string, quantity: string}[], valid: {type: boolean, quantity: boolean}[]},
  setTypeDeadline?: Dispatch<SetStateAction<{value: string, valid: boolean}>>,
  setPaymentDeadlines?: Dispatch<SetStateAction<{value: {id: string, type: string, quantity: string}[], valid: {type: boolean, quantity: boolean}[]}>>
};

const AppInputDeadlineType: React.FunctionComponent<AppInputDeadlineTypeProps> = ({component, options, typeDeadline, paymentDeadlines, setTypeDeadline, setPaymentDeadlines}) => {
  const {lang} = StateLanguage()

  const handleChangeType = (item: string) => {
    if (typeDeadline && setTypeDeadline) {
      setTypeDeadline({value: item, valid: true})
      legendValid(`${prefixLegend(component)}legend-type-required`)
    }
  }

  const handleChangeDeadlineTypeList = (index: number, item: string) => {
    if (paymentDeadlines && setPaymentDeadlines) {
      let tempDeadlinesValue = paymentDeadlines.value.map((temp_item, temp_index) => {
        if (index === temp_index) {
          temp_item.type = item
        }
        return temp_item
      })
      let tempDeadlinesValid = paymentDeadlines.valid.map((temp_item, temp_index) => {
        if (index === temp_index) {
          temp_item.type = true
        }
        return temp_item
      })

      setPaymentDeadlines({value: tempDeadlinesValue, valid: tempDeadlinesValid})
      legendValid(`${prefixLegend(component)}legend-deadline-type-required${suffixLegend(index)}`)
    }
  }

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-100 p-0">
          <span className="selection">
            <span className="select2-selection select2-selection--single form-select">
              <span className="select2-selection__rendered" role="textbox">
                { typeDeadline &&
                  <>
                    {typeDeadline.valid ? deadlineTypeValue(lang, typeDeadline.value, false) : lang.labels.selectOption}
                  </>
                }
                { options && paymentDeadlines &&
                  <>
                    {paymentDeadlines.valid[options.index].type ? deadlineTypeValue(lang, options.item.type, false) : lang.labels.selectOption}
                  </>
                }
              </span>
            </span>
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open w-100">
          <span className="select2-dropdown select2-dropdown--below">
            <span className="select2-results">
              <ul className="select2-results__options" role="listbox">
                { typeDeadline && deadlineTypeList(lang).map (( (item, index) => { return (
                  <li key={index} className={`select2-results__option select2-results__option--selectable ${typeDeadline.value === item.code && "select2-results__option--selected"}`} role="option" aria-selected={typeDeadline.value === item.code}>
                    <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangeType(item.code)}>{item.display_singular}</Dropdown.Item>
                  </li>
                )}))}
                { options && paymentDeadlines && deadlineTypeList(lang).map (( (item, index) => { return (
                  <li key={index} className={`select2-results__option select2-results__option--selectable ${options.item.type === item.code && "select2-results__option--selected"}`} role="option" aria-selected={options.item.type === item.code}>
                    <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangeDeadlineTypeList(options.index, item.code)}>{item.display_singular}</Dropdown.Item>
                  </li>
                )}))}
              </ul>
            </span>
          </span>
        </Dropdown.Menu>
      </Dropdown>
      { typeDeadline &&
        <AppLegend component={component} attribute={{check: typeDeadline.valid, name: "type", index: null, sub_index: null}} container={{valid: false, required: true, identical: false, exists: false}}></AppLegend>
      }
      { options && paymentDeadlines &&
        <AppLegend component={component} attribute={{check: paymentDeadlines.valid[options.index].type, name: "deadline-type", index: options.index, sub_index: null}} container={{valid: false, required: true, identical: false, exists: false}}></AppLegend>
      }
    </>
  )
}

export default AppInputDeadlineType;
